<template>
  <div class="home">
    <HelloWorld msg="Studio 88" />
  </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue';

export default {
  name: 'Home',

  components: {
    HelloWorld,
  },
};
</script>
